import * as React from "react";
import logo from "../../images/Logos/SYBLogo.svg";

export default function NavLogo() {
  return <img src={logo} style={{ height: "90%", objectFit: "cover" }} />;
}
